
/**
 * Checkes a input matches against a regex pattern string
 * 
 * @param {string} pattern to match string against
 * @param {string} input to match against pattern
 * @param {func}   onError called when input tested against pattern
 * 
 * @returns true if input matches pattern
 */
const validate = (pattern: RegExp, input: string) => {
  let regex = new RegExp(pattern)
  return regex.test(input)
}

/**
 * Checks if input is a non empty string.
 * 
 * @param {string} input to match
 * @param {func}   onError to be called when input is checked against pattern
 * 
 * @returns true if input is a non empty string
 */
export const anyMoreThanOnce = (input: string) => {
  return validate(/^.+$/, input)
}

/**
 * Checks if input is a non empty integer string.
 * 
 * @param {string} input to check
 * @param {func}   onError called when input checked against pattern
 */
export const intMoreThanOnce = (input: string) => {
  return validate(/^[0-9]+$/, input)
}

/**
 * Checks if input is a non empty positive or negative integer string.
 * 
 * @param {string} input to check
 * @param {func}   onError called when input checked against pattern
 */
export const negtiveMoreThanOnce = (input: string) => {
  return validate(/^-?[0-9]+$/, input)
}

/**
 * Checks if an input is a non empty float string.
 * 
 * @param {string} input string to check
 * @param {func} onError called when input checked against pattern
 * 
 * @returns true if input is a non empty float string
 */
export const floatMoreThanOnce = (input: string) => {
  return validate(/^\d+(\.\d{1,3})?$/, input)
}

/**
 * Checks if an input is a non empty float string that can be negative.
 * 
 * @param {string} input string to check
 * @param {func} onError called when input checked against pattern
 * 
 * @returns true if input is a non empty float string
 */
export const possibleNegativefloatMoreThanOnce = (input: string) => {
  return validate(/^-?\d+(\.\d{1,3})?$/, input)
}
